/** Throw an error in production and assert something will never happen in TS */
export function assertNever(data: never): never {
  throw new Error(`assertNever: ${data}`);
}

/** Like `assertNever` but only at the type level, no runtime behavior */
export function assertNeverSoftly(data: never): void {
  data; // eslint-disable-line @typescript-eslint/no-unused-expressions
}
